import { useEffect, useState } from 'react';

/**
 * Detect whether the app is loaded inside the platform.
 *
 * Source of truth: the URL query param `?embed=1`. No storage — the flag
 * is threaded through internal navigations by `useEmbedAwareNavigate`, so
 * the URL always carries it during an embed session.
 */

const BODY_CLASS = 'embed-mode';

function readFromSearch(search) {
  return new URLSearchParams(search || '').get('embed') === '1';
}

function readFromWindow() {
  if (typeof window === 'undefined') return false;
  return readFromSearch(window.location.search);
}

export function useEmbedMode() {
  const [isEmbed, setIsEmbed] = useState(readFromWindow);

  useEffect(() => {
    const recheck = () => setIsEmbed(readFromWindow());
    window.addEventListener('popstate', recheck);
    return () => window.removeEventListener('popstate', recheck);
  }, []);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    document.body.classList.toggle(BODY_CLASS, isEmbed);
  }, [isEmbed]);

  return isEmbed;
}
